import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useQuery } from "@apollo/react-hooks";
import { ApolloProvider } from "@apollo/react-hooks";
import { apolloClient } from "js/apollo/apollo-client";

import { GET_PHOTOS_BY_CREATOR } from "./queries";

import PhotosGrid from "photos/PhotosGrid";
import LoadingSpinner from "core/LoadingSpinner";

export const OldGridContainer = styled.div`
    max-width: 964px;
`;

export const ProfilePhotos = ({ creator }) => {
    const { loading, data } = useQuery(GET_PHOTOS_BY_CREATOR, {
        variables: {
            creator: creator,
            limit: 12
        },
        skip: !creator,
        fetchPolicy: "cache-and-network"
    });

    const defaultWidth = 964;

    const [pathWidth, setPageWidth] = useState(defaultWidth);

    useEffect(() => {
        const onResize = () => {
            setPageWidth(
                window.innerWidth < defaultWidth
                    ? window.innerWidth
                    : defaultWidth
            );
        };
        window.addEventListener("resize", onResize);

        return () => {
            window.removeEventListener("resize", onResize);
        };
    });

    if (loading) {
        return <LoadingSpinner />;
    }

    const isSubscribed = true; // We don't want to show ads here

    return (
        <PhotosGrid
            data={data}
            subscribed={isSubscribed}
            useRouterLink={false}
            pageWidth={pathWidth}
            itemKey="browsePhotosByCreator"
            maxRows={3}
        />
    );
};

// This component will be embedded in a Django template for now, so it needs
// its own ApolloProvider.
export const ProfilePhotosWrapper = ({ args: { creator } }) => {
    // Use className="container" to pick up styles from the old grid.
    return (
        <ApolloProvider client={apolloClient}>
            <OldGridContainer className="container">
                <ProfilePhotos creator={creator} />
            </OldGridContainer>
        </ApolloProvider>
    );
};

export default ProfilePhotosWrapper;
